export * from './lib/app-client-shared-components-menu-content-ui.module';
